import { render, staticRenderFns } from "./messageDeliveryDetails.vue?vue&type=template&id=58879a98"
import script from "./messageDeliveryDetails.vue?vue&type=script&lang=js"
export * from "./messageDeliveryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports